import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

interface SearchHeaderProps {
  search: string;
  searchBarPlaceHolder?: string;
  handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SearchHeader = ({
  search,
  searchBarPlaceHolder,
  handleSearchChange,
}: SearchHeaderProps) => {
  const { t } = useTranslation();
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" />
      <input
        type="text"
        placeholder={t(searchBarPlaceHolder || "Search...")}
        value={search}
        onChange={handleSearchChange}
        className="w-full pl-10 pr-4 py-2 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-primaryText dark:text-primaryTextDark focus:outline-none focus:ring-2 focus:ring-secondaryText dark:focus:ring-secondaryTextDark"
      />
    </div>
  );
};
